import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaCaretDown from 'react-icons/lib/fa/caret-down';

import styles from './CaretIcon.scss';

const propTypes = {
    className: PropTypes.string,
    showUpArrow: PropTypes.bool,
};

/**
 * Visual affordance to indicate expand/collapse state of a
 * component; defaults to pointing down (i.e. closed).
 *
 * Expand/collapse state should be semantically indicated
 * elsewhere, likely by the parent component.
 *
 * @param {string} [className] CSS class
 * @param {boolean} showUpArrow arrow direction
 * @returns {React.StatelessComponent}
 */
function CaretIcon({ className, showUpArrow = false }) {
    return (
        <FaCaretDown
            aria-hidden={true}
            className={classNames(
                styles.caretIcon,
                { [styles.isUp]: showUpArrow },
                className,
            )}
            focusable={false}
        />
    );
}

CaretIcon.propTypes = propTypes;

export default CaretIcon;
